import * as http from "../../index";
import Configuration from "../../../config/index";
import { createRequest } from "./utils";
export const getUrl = (orderRef) => {
    const host = Configuration.current().getApiAddress();
    const url = `${host}/bankid/cancel/${orderRef}`;
    return url;
};
export const cancel = (requestOptions) => {
    const url = getUrl(requestOptions.orderRef);
    const request = createRequest();
    return http.raw(url, request);
};
